import { newStorage } from './storage';

const usersTableStorage = newStorage('TABLE_USERS');

export default usersTableStorage;
